import accessibleAutocomplete from "accessible-autocomplete";
import Cookies from "js-cookie";
import sanitizeHtml from "sanitize-html";
import utils from "../helpers/utils";

const HIDDEN_CLASSNAME = "hidden";

function init(): void {
  const container = document.getElementById("my-autocomplete-container-top");
  const form = document.getElementById("search-box__container-form") as HTMLFormElement;
  let input;

  if (!container || !container.dataset.settings) {
    return;
  }

  const { placeholder, prefixUrl, inputId, minLength, maxResults, clearButtonId } = JSON.parse(
    container.dataset.settings
  );

  if (!inputId || !prefixUrl) {
    return;
  }

  const clearSearch = document.getElementById(clearButtonId);

  const openItem = (item): boolean => {
    const url = item && item.url;
    if (url) {
      window.open(url, "_self");
    }
    return false;
  };

  if (clearSearch) {
    clearSearch.onclick = () => {
      input = document.getElementById(inputId) as HTMLInputElement;
      if (input && input.value) {
        input.value = "";
        input.blur();
        clearSearch.classList.add(HIDDEN_CLASSNAME);
      }
    };
  }

  form?.addEventListener(
    "submit",
    () => {
      if (input && input.value) {
        input.value = sanitizeHtml(input.value);
      }
    },
    false
  );

  if (!input) {
    const navToggles = document.querySelectorAll(".js-nav-search-toggle, .js-nav-toggle");
    navToggles.forEach((el) => {
      el.addEventListener("click", (_event) => {
        // Once the user clicks the navToggle, this input will have mounted. Would be nicer with MutationObserver but this works & is a lot more readable
        input = document.getElementById(inputId) as HTMLInputElement;
        if (input) {
          input.addEventListener("keyup", function (event) {
            const enterKey = event.which === 13 || event.code === "Enter" || event.keyCode === 13;

            if (enterKey) {
              event.stopPropagation();
              event.preventDefault();
              input.value = sanitizeHtml(input.value);
              if (form) {
                form.submit();
              }
            }

            // Show / hide the x button
            if (clearSearch) {
              const query = input.value;
              if (!!query && query.length) {
                clearSearch.classList.remove(HIDDEN_CLASSNAME);
              } else {
                clearSearch.classList.add(HIDDEN_CLASSNAME);
              }
            }
          });
        }
      });
    });
  }

  const searchApi = (query, syncResults) => {
    const role = Cookies.get("Role") || undefined;
    const region = Cookies.get("Region") || undefined;
    const params = {
      maxResults: maxResults || 5,
      query: sanitizeHtml(query),
      role,
      region,
    };

    if (!params.query) {
      return;
    }
    const queryString = utils.serializeParams(params);
    const url = `${prefixUrl}?${queryString}`;

    fetch(url)
      .then((res) => {
        if (res.status !== 200) {
          console.error(`There was a problem. Status Code: ${res.status}`);
          return [];
        }
        res
          .json()
          .then((data) => {
            const results = data.length ? data : [];
            syncResults(results);
          })
          .catch((err) => {
            console.error(err);
            return [];
          });
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  };

  accessibleAutocomplete({
    element: container,
    id: inputId, // Has to match the <label>
    source: searchApi,
    onConfirm: openItem,
    displayMenu: "overlay",
    minLength: minLength || 3,
    placeholder,
    templates: {
      inputValue: (item) => {
        return item && item.title;
      },
      suggestion: (item) => {
        if (typeof item === "object") {
          return `<a href="${item.url}" class="autocomplete__option-link">${item.title}</a>`;
        } else {
          return item; // Fallback to turn into a typeahead
        }
      },
    },
    // showNoOptionsFound: false,
    tNoResults: () => {
      return "No suggestions found";
    },
    tStatusNoResults: () => {
      return "No suggestions found";
    },
  });
}

export default { init };
